import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider, theme } from 'custom-test-antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

// register container and resolve necessary services
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { container as _iocContainer } from 'ioc-container';

import App from 'components/application';
import './index.pcss';
import { PostHogProvider } from 'posthog-js/react';
import Service from 'ioc-container/service-keys';
import { PosthogServiceInterface } from 'services/PosthogService';

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);
dayjs.tz.setDefault('Asia/Dubai');

const container = document.getElementById('root');
if (container) {
  const posthogService = _iocContainer.resolve<PosthogServiceInterface>(Service.posthog);
  posthogService.init();
  const root = createRoot(container);
  root.render(
    <ConfigProvider theme={theme}>
      <PostHogProvider client={posthogService.getClient()}>
        <App />
      </PostHogProvider>
    </ConfigProvider>,
  );
}
